// Module
var code = "<div class=\"container\"><react-component name=\"MonthlyRunRatesGraphs\"></react-component></div>\n";
// Exports
module.exports = code;